<template>
  <div>
    <div class="form-line">
      <div class="textBox" style="margin-right: 0">
        <b class="red">*</b>
        <span class="line-text">启用：</span>
      </div>
      <el-switch
        v-model="useFlagOnPage"
        @change="changeSwitch"
        active-text="是"
        :disabled="!modifyState"
        inactive-text="否"
      >
      </el-switch>
    </div>
    <template v-if="useFlagOnPage">
      <div
        class="config-item"
        v-for="(item, index) in flowDetails"
        :key="item.index"
      >
        <div class="config_title">
          <div class="config_title_text">{{ item.gradeNum }}级审批配置</div>
          <img
            src="../../../../../assets/approval/icon_add.png"
            class="icon_add"
            alt=""
            @click="addFlowDetails()"
            v-if="index < 2 && index === flowDetails.length - 1 && modifyState"
          />
          <img
            src="../../../../../assets/approval/icon_reduce.png"
            class="icon_reduce"
            alt=""
            @click="removeFlowDetails(index)"
            v-if="index > 0 && modifyState"
          />
        </div>
        <div class="form-line-fa">
          <div class="form-line">
            <div class="textBox" style="margin-right: 0;">
              <b class="red" v-if="useFlagOnPage">*</b>
              <span class="line-text">审批人数：</span>
            </div>
            <div class="btn_fa">
              <el-button
                :disabled="!modifyState"
                :class="item.isSingle ? 'isClick' : 'noClick'"
                @click="item.isSingle = true"
                >单人</el-button
              >
              <el-button
                :disabled="!modifyState"
                :class="!item.isSingle ? 'isClick' : 'noClick'"
                @click="item.isSingle = false"
                >多人</el-button
              >
            </div>
          </div>
          <div class="form-line form-line-second" v-if="!item.isSingle">
            <div class="textBox" style="margin-right: 0;">
              <b class="red" v-if="useFlagOnPage">*</b>
              <span class="line-text">审批方式：</span>
            </div>
            <el-radio-group
              v-model="item.approvalMode"
              :disabled="!modifyState"
            >
              <el-radio
                label="1"
                style="display: flex;justify-content: left;align-items: center"
              >
                <span>会签</span>
                <el-tooltip
                  class="item"
                  effect="dark"
                  :content="countersignContent"
                  placement="top-start"
                >
                  <img src="../../../../../assets/approval/icon_tooltip.png" />
                </el-tooltip>
              </el-radio>
              <el-radio
                label="2"
                style="display: flex;justify-content: left;align-items: center"
              >
                <span>或签</span>
                <el-tooltip
                  class="item"
                  effect="dark"
                  :content="orSignContent"
                  placement="top-start"
                >
                  <img src="../../../../../assets/approval/icon_tooltip.png" />
                </el-tooltip>
              </el-radio>
            </el-radio-group>
          </div>
          <div class="form-line" v-if="item.isSingle">
            <div class="textBox" style="margin-right: 0;">
              <b class="red" v-if="useFlagOnPage">*</b>
              <span class="line-text">审批人：</span>
            </div>
            <el-select
              v-model="item.accountCode"
              filterable
              remote
              reserve-keyword
              placeholder="请输入关键词"
              :loading="accountLoading"
              size="mini"
              style="width: 220px"
              :disabled="!modifyState"
              @change="accountChange($event, index)"
              :remote-method="accountRemoteMethod"
            >
              <el-option
                v-for="item in accountList"
                :key="item.code"
                :label="item._lable"
                :value="item.code"
              >
              </el-option>
            </el-select>
          </div>
          <div v-else class="form-line-multiple-people">
            <div
              class="form-line"
              v-for="(ite, dex) in item.flowNodePersons"
              :key="dex"
            >
              <div class="textBox" style="margin-right: 0;">
                <b class="red" v-if="useFlagOnPage">*</b>
                <span class="line-text">{{ item.gradeNum }}级审批人：</span>
              </div>
              <div
                style="display: flex;justify-content: left;align-items: unset;margin-right: 0"
              >
                <el-select
                  v-model="ite.accountCode"
                  filterable
                  remote
                  reserve-keyword
                  placeholder="请输入关键词"
                  :loading="accountLoading"
                  size="mini"
                  style="width: 220px"
                  :disabled="!modifyState"
                  @change="accountChange2($event, dex, index)"
                  :remote-method="accountRemoteMethod"
                >
                  <el-option
                    v-for="item in accountList"
                    :key="item.code"
                    :label="item._lable"
                    :value="item.code"
                  >
                  </el-option>
                </el-select>
                <div
                  class="clear_approver"
                  @click="clearApprover(index, dex)"
                  v-if="dex > 0 && modifyState"
                >
                  x
                </div>
                <div
                  class="clear_approver"
                  style="visibility: hidden;"
                  v-else
                ></div>
              </div>
              <span
                class="add_approver"
                @click="addApprover(index)"
                v-if="
                  dex < 9 &&
                    dex === flowDetails[index].flowNodePersons.length - 1 &&
                    modifyState
                "
                >添加审批人</span
              >
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import { api } from '../../../../api/ConfigManagement'
import { errorHandler } from '../../../../../utils/errorHandler'

export default {
  name: 'configContent',
  props: {
    flowNodeConfigs: Array,
    modifyState: Boolean,
  },
  model: {
    prop: 'flowNodeConfigs',
    event: 'newValue',
  },
  data() {
    return {
      useFlagOnPage: false,
      accountLoading: false,
      accountList: [],
      countersignContent:
        '指同一个审批节点设置多个人，如ABC三人，三人会同时收到审批，需全部同意之后，审批才可到下一审批节点',
      orSignContent:
        '指同一个审批节点设置多个人，如ABC三人，三人会同时收到审批，只要其中任意一人审批即可到下一审批节点',
      flowDetails: this.flowNodeConfigs,
    }
  },
  mounted() {
    this.accountRemoteMethod()
  },
  watch: {
    flowDetails: {
      handler() {
        this.$emit('newValue', this.flowDetails)
      },
      deep: true,
    },
  },
  methods: {
    // 搜索账号
    accountRemoteMethod(query) {
      this.accountLoading = true
      this.$axios
        .post(api.getAccountList, {
          searchKey: query,
        })
        .then((res) => {
          if (res.data.retCode === 1) {
            this.accountLoading = false
            let data = res.data.data
            data.map((v) => {
              v._lable = `${v.name}/${v.actualName}/${v.phone}`
            })
            this.accountList = data
          }
        })
        .catch(errorHandler('获取账号列表失败'))
    },

    // 选择账号（单人节点）
    accountChange(code, index) {
      let target = this.accountList.find((v) => v.code === code)
      if (target) {
        this.flowDetails[index].personCode = target.personCode
        this.flowDetails[index].personName = target.actualName
        this.flowDetails[index].accountName = target.name
      } else if (!code) {
        this.flowDetails[index].personCode = ''
        this.flowDetails[index].personName = ''
        this.flowDetails[index].accountName = ''
      }
    },

    // 选择账号（多人节点中的某一审批人）
    accountChange2(code, dex, index) {
      let target = this.accountList.find((v) => v.code === code)
      if (target) {
        this.flowDetails[index].flowNodePersons[dex].personCode =
          target.personCode
        this.flowDetails[index].flowNodePersons[dex].personName =
          target.actualName
        this.flowDetails[index].flowNodePersons[dex].accountName = target.name
      } else if (!code) {
        this.flowDetails[index].flowNodePersons[dex].personCode = ''
        this.flowDetails[index].flowNodePersons[dex].personName = ''
        this.flowDetails[index].flowNodePersons[dex].accountName = ''
      }
    },

    // 添加一行（级）
    addFlowDetails() {
      let flowDetailsLength = this.flowDetails.length
      let gradeNum = ''
      if (flowDetailsLength === 1) {
        gradeNum = '二'
      } else {
        gradeNum = '三'
      }
      let obj = {
        accountCode: '',
        accountName: '',
        personCode: '',
        personName: '',
        index: flowDetailsLength + 1,
        idx: flowDetailsLength + 1,
        isSingle: true,
        approvalMode: '1',
        numberType: '1',
        gradeNum: gradeNum,
        flowNodePersons: [
          {
            index: 1,
            idx: 1,
            accountCode: '',
            accountName: '',
            personCode: '',
            personName: '',
          },
        ],
      }
      this.flowDetails.push(obj)
    },

    // 移除一行（级）
    removeFlowDetails(index) {
      this.flowDetails.splice(index, 1)
      this.flowDetails.map((v, i) => {
        v.index = i + 1
        v.idx = i + 1
        if (i === 0) {
          v.gradeNum = '一'
        } else if (i === 1) {
          v.gradeNum = '二'
        } else {
          v.gradeNum = '三'
        }
      })
    },

    // 添加审批人
    addApprover(index) {
      let flowDetailsLength = this.flowDetails[index].flowNodePersons.length
      let gradeNum = ''
      if (flowDetailsLength === 1) {
        gradeNum = '二'
      } else {
        gradeNum = '三'
      }
      let obj = {
        index: flowDetailsLength + 1,
        idx: flowDetailsLength + 1,
        accountCode: '',
        accountName: '',
        personCode: '',
        personName: '',
        gradeNum: gradeNum,
      }
      this.flowDetails[index].flowNodePersons.push(obj)
    },

    // 删除审批人
    clearApprover(index, idx) {
      this.flowDetails[index].flowNodePersons.splice(idx, 1)
      this.flowDetails[index].flowNodePersons.map((v, i) => {
        v.index = i + 1
        v.idx = i + 1
        if (i === 0) {
          v.gradeNum = '一'
        } else if (i === 1) {
          v.gradeNum = '二'
        } else {
          v.gradeNum = '三'
        }
      })
    },

    changeSwitch() {
      this.$emit('changeSwitch', this.useFlagOnPage)
    },
  },
}
</script>

<style scoped>
.form-line .textBox {
  width: 120px;
  height: unset;
  font-size: 0.09rem;
  line-height: 0.1rem;
}
.config_title {
  display: flex;
  justify-content: left;
  align-items: center;
}
.config_title_text {
  width: 0.79rem;
  height: 0.2rem;
  line-height: 0.2rem;
  background-color: #999999;
  color: #fff;
  text-align: center;
  font-size: 0.1rem;
  font-weight: 500;
}
.icon_add {
  width: 0.13rem;
  height: 0.13rem;
  margin-left: 0.08rem;
  cursor: pointer;
}
.icon_reduce {
  width: 0.13rem;
  height: 0.13rem;
  margin-left: 0.08rem;
  cursor: pointer;
}
.form-line-fa {
  width: 6.4rem;
  /*height: 0.9rem;*/
  background-color: #f8f8f8;
  border-radius: 0 0 0.02rem 0.02rem;
  overflow: hidden;
  padding: 0.13rem 0;
}
.btn_fa {
  display: flex;
  justify-content: left;
  align-items: center;
}
.form-line {
  align-items: center;
  margin-top: 0;
  margin-bottom: 0.13rem;
}
.form-line:last-child {
  margin-bottom: 0;
}
.red {
  vertical-align: unset;
  line-height: 0.1rem;
}
.form-line-second {
  font-size: 0.08rem;
}
.form-line-second .textBox .line-text {
  font-size: 0.08rem;
  line-height: 0.1rem;
}
.isClick {
  color: #1362ff !important;
  border-color: #1362ff !important;
  background-color: unset;
}
.noClick {
  color: #606266;
  border-color: #dcdfe6;
  background-color: #fff;
}
.form-line-second img {
  width: 0.08rem;
  height: 0.08rem;
  margin-left: 0.04rem;
}
.clear_approver {
  width: 0.07rem;
  height: 0.07rem;
  line-height: 0.07rem !important;
  text-align: center;
  background: #333333;
  font-size: 0.05rem;
  border-radius: 50%;
  color: #fff;
  cursor: pointer;
  margin-top: -0.035rem;
  margin-left: -0.035rem;
  z-index: 1;
}
.add_approver {
  cursor: pointer;
  font-size: 0.07rem;
  font-weight: 400;
  color: #1362ff;
  margin-left: 0.08rem;
}
.form-line-multiple-people {
  display: flex;
  flex-wrap: wrap;
  justify-content: left;
  align-items: center;
}
.form-line-multiple-people .form-line {
  margin-right: 0px;
  margin-bottom: 16px;
}
.config-item {
  margin-bottom: 0.15rem;
}
</style>
<style lang="less" scoped>
.btn_fa /deep/ .el-button {
  padding: 0.03rem 0.08rem;
  font-size: 0.07rem;
}
/deep/.el-input--mini .el-input__inner {
  height: 0.15rem !important;
  line-height: 0.15rem !important;
}
/deep/.el-button:hover {
  color: #1362ff;
  border-color: #1362ff;
  background-color: unset;
}
/deep/.form-line > div div:last-child {
  line-height: unset;
}
/deep/.el-radio__label {
  display: flex;
  justify-content: left;
  align-items: center;
  font-size: 0.08rem;
}
/deep/.el-button.is-disabled,
.el-button.is-disabled:focus,
.el-button.is-disabled:hover {
  opacity: 0.5;
}
/deep/.el-button.is-disabled:hover {
  color: #1362ff;
  border-color: #1362ff;
  opacity: 0.5;
}
</style>



// WEBPACK FOOTER //
// src/view/ResourceCenter/configManagement/ApprovalConfig/components/configContent.vue